import { NgModule } from '@angular/core';
import { TodoComponent } from './todo.component';
import { TodoTableComponent } from './todo-table/todo-table.component';
import { WsgSharedModule } from '@morningstar/wsg/shared';
import { TodoService } from './todo.service';
import { ChecklistTypeModule } from '../../shared/pipes/checklist-type/checklist-type.module';
import { EllipsisModule } from '../../shared/pipes/ellipsis/ellipsis.module';
import { EditTodoDialogComponent } from './edit-todo-dialog/edit-todo-dialog.component';

@NgModule({
  declarations: [
    TodoComponent,
    TodoTableComponent,
    EditTodoDialogComponent
  ],
  imports: [
    WsgSharedModule,
    ChecklistTypeModule,
    EllipsisModule
  ],
  providers: [
    TodoService
  ],
  exports: [
    TodoComponent
  ]
})
export class TodoModule { }
